import { ReactNode, useMemo, useState } from 'react';
import styles from './SelectMetric.module.scss'
import {
  FiChevronDown as ExpandDropdownIcon,
  FiChevronUp as CollapseDropdownIcon,
} from "react-icons/fi";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";

import Select, { StylesConfig, components } from 'react-select';
import { defaultTheme } from 'react-select';
import { TypeOfFinanceOption } from '../../../../interfaces/interfaces';

const { colors } = defaultTheme;

const selectStyles: any = {
  control: (provided) => ({
    ...provided,
    minWidth: 240,
    margin: 8,
    border: 0,
    fontFamily: "Work Sans",
    fontSize: "0.6875rem",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "0.875rem", /* 127.273% */
    letterSpacing: "0.00688rem",
    boxShadow: "none",
    backgroundColor: "#E7EBF3",
  }),
  input: (provided) => ({
    ...provided,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%"
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '200px',
    overflow: 'auto',
    padding: 0,
    borderRadius: '0 0 0.5rem 0.5rem',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontFamily: 'Work Sans',
    fontSize: '0.78571rem',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '1rem',
    letterSpacing: '0.00786rem'
  }),
  menu: () => ({ backgroundColor: "#fff", width: "259px", border: "1px solid #d4d4d4", borderRadius: "0 0 0.5rem 0.5rem", borderTop: "none", boxShadow: "0 0 0 1px hsla(218, 50%, 10 %, 0.1), 0 4px 11px hsla(218, 50%, 10 %, 0.1)", padding: "0" }),
  menuPortal: (base) => ({
    ...base, zIndex: 9999,
    marginLeft: "-0.55rem",
    marginTop: "0.52rem",
    borderTop: "1px solid #d4d4d4"
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    const paddingLeft = data.type == "metric" ? "2rem" : "1rem";

    return {
      ...styles,
      overflowX: "hidden",
      textOverflow: "ellipsis",
      cursor: "pointer",
      fontFamily: "Work Sans",
      fontSize: "0.6875rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "0.875rem",
      letterSpacing: "0.00688rem",
      backgroundColor: "transparent",
      color: isSelected ? "#965ae5" : "#808080",
      borderTop: "1px solid #d5d5d5",
      paddingLeft: paddingLeft,
      padding: "0.75rem 1rem 0.75rem 1rem",
      ":first-of-type": {
        borderTop: "1px solid #fff",
      },
      ":active": {
        ...styles[":active"],
        backgroundColor: "transparent",
      },
    };
  },
};

type Props = {
  options: {
    id: number;
    label: string;
    type: TypeOfFinanceOption,
    value: string;
  }[] | {
    uuid: string,
    channel?: string,
    value?: number,
    dataSource?: string
  }[],
  handleSelectedValue: (value) => void,
  value: any;
}

// const Input = props => <components.Input {...props} maxLength={40} />;

const CustomInput = props => (
  <components.Input {...props} inputClassName="custom-select-metric-pnl" maxLength={70} />
);

const SelectMetricCustom = ({ options, handleSelectedValue, value }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  // const [value, setValue] = useState(null);

  // console.log('value', value, "isOpen", isOpen);

  const sliceLabel = useMemo(() => {
    if (value && value?.feLabel.toString().length > 25) {
      return `${value?.feLabel.slice(0, 30)}...`
    } else {
      return value?.feLabel
    }
  }, [value])

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false)
      }}
      target={
        <button
          type='button'
          className={styles.dropdownBtn}
          // iconAfter={<ChevronDown />}
          onClick={(e) => {
            e.stopPropagation();
            // console.log('onClick')
            setIsOpen((prev) => !prev)
          }}
        // isSelected={isOpen}
        >
          <div className={styles.btnContainer}>
            <div className={styles.btnText}>
              {value ? `${sliceLabel}` : 'Select Metric'}
            </div>
            <div className={styles.iconContainer}>
              <ExpandDropdownIcon />
            </div>
          </div>
        </button>
      }
    >
      {/* <div>mdmdmdm</div> */}


      <Select
        autoFocus
        backspaceRemovesValue={false}
        components={{ DropdownIndicator: SearchIconIndicator, IndicatorSeparator: null, MenuList: CustomMenuList, Input: CustomInput }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen={true}
        onChange={(newValue) => {
          console.log('new value', newValue)
          handleSelectedValue(newValue)
          // setValue(newValue);
          setIsOpen(false);
        }}
        options={options}
        placeholder="Search..."
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
        menuPortalTarget={document.body}
      />
    </Dropdown>
  );
};


export default SelectMetricCustom;
// styled components

const CustomMenuList = (props) => {
  return (
    <components.MenuList {...props} className={styles.menuList}>
      {props.children}
    </components.MenuList>
  );
};

const SearchIconIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <SearchIcon />
    </components.DropdownIndicator>
  );
};


const Menu = (props: JSX.IntrinsicElements['div']) => {
  const shadow = 'hsla(218, 50%, 10%, 0.1)';
  return (
    <div
      className={styles.menu}
      {...props}
    />
  );
};
const Blanket = (props: JSX.IntrinsicElements['div']) => (
  <div
    className='blanket'
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: 'fixed',
      zIndex: 2000,
    }}
    {...props}
  />
);
const Dropdown = ({
  children,
  isOpen,
  target,
  onClose,
}: {
  children?: ReactNode;
  readonly isOpen: boolean;
  readonly target: ReactNode;
  readonly onClose: () => void;
}) => (
  <div
    className={styles.dropdownContainer}
  // style={{ position: 'relative', zIndex: "1059" }}
  >
    {target}
    {isOpen ? <Menu>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);
const Svg = (p: JSX.IntrinsicElements['svg']) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
const DropdownIndicator = () => (
  <div style={{ color: colors.neutral20, height: 24, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);
const ChevronDown = () => (
  <Svg style={{ marginRight: -6 }}>
    <path
      d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Svg>
);